import {Injectable} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {ProductService} from './api/product-configuration/product.service';

/**
 *Interfaces
 */
interface Item {
    id: number;
    value: string;
    parent_id: number;
    disabled?: boolean;
}

interface Group {
    id: number;
    name: string;
    variant: Item[];
    disabled?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class MultiSelectService {
    groups: Group[];

    constructor(private productService: ProductService) {
    }

    getVariants(): Promise<any> {
        return Promise.resolve((() => {
            return this.productService.getVariants().then((data: Object) => data['data'], (error: HttpErrorResponse | any) => console.log('getVariants', error));
        })());
    }
}
